import { render, staticRenderFns } from "./AdminEventDetails.vue?vue&type=template&id=36b2d094&scoped=true&"
import script from "./AdminEventDetails.vue?vue&type=script&lang=js&"
export * from "./AdminEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdminEventDetails.vue?vue&type=style&index=0&id=36b2d094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2d094",
  null
  
)

export default component.exports